import type { Insight } from "@tandemdiabetes/sugarmate-api-react-client"
import { animationDurationInSeconds } from "./SortableTile"
import styles from "./Tile.module.scss"
import { TileChildren } from "./TileChildren"

interface Props {
  id: string;
  insight: Insight;
}

export function OverlayTile(props: Props) {
  return (
    <div
      className={styles.container}
      id={props.id}
    >
      <button
        className={styles.overlayTileButton}
        type="button"
      >
        <TileChildren
          {...props}
          className={styles.wiggling}
          style={{ animationDuration: `${animationDurationInSeconds}s` }}
        />
      </button>
    </div>
  )
}
